import { gql } from '@apollo/client';

export const GET_USERS = gql`
  {
    allUsers{
      id
      name
      email
      division
      position
      role
      username
    }
  }
`;

export const GET_USER_BY_USERNAME = gql`
  query GetUserByUsername($username: String!) {
    getUserByUsername(username: $username) {
      id
      name
      email
      division
      position
      role
    }
  }
`;
